import React, { useState, useEffect, useContext, useRef } from "react";
import "../../../../constants/report.css";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import { tempUrl } from "../../../../contexts/ContextProvider";
import { Loader } from "../../../../components";
import {
  Box,
  ButtonGroup,
  Button,
  Autocomplete,
  TextField,
} from "@mui/material";
import { Container, Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import { useDownloadExcel } from "react-export-table-to-excel";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import useScreenWidth from "../../../../hooks/useScreenWidth";
import { formatDate } from "../../../../constants/helper";

const LaporanKas = () => {
  const screenSize = useScreenWidth();
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const reportTemplateRef = useRef(null);
  let nowDate = new Date();
  let [sampaiTanggal, setSampaiTanggal] = useState(
    new Date(user.tutupperiode.sampaiTanggal),
  );
  // let [dariTanggal, setDariTanggal] = useState(
  //   new Date(user.tutupperiode.dariTanggal)
  // );
  const [kodeCabang, setKodeCabang] = useState("");
  const [namaCabang, setNamaCabang] = useState("");

  const [cabangs, setCabangs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [persenLoading, setPersenLoading] = useState("0");
  const [penerimaanKas, setPenerimaanKas] = useState([]);
  const [penerimaanKasSampaiSekarang, setPenerimaanKasSampaiSekarang] =
    useState([]);
  const [
    totalPenerimaanKasSampaiSekarang,
    setTotalPenerimaanKasSampaiSekarang,
  ] = useState(0);
  const [pengeluaranKas, setPengeluaranKas] = useState([]);
  const [pengeluaranKasSampaiSekarang, setPengeluaranKasSampaiSekarang] =
    useState([]);
  const [
    totalPengeluaranKasSampaiSekarang,
    setTotalPengeluaranKasSampaiSekarang,
  ] = useState([]);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isCetakExcel, setIsCetakExcel] = useState(false);
  const [error, setError] = useState(false);

  let cabangOptions = cabangs.map((cabang) => ({
    label: `${cabang.id} - ${cabang.namaCabang}`,
    id: `${cabang.id} - ${cabang.namaCabang}`,
  }));

  const generatePDF = useReactToPrint({
    content: () => reportTemplateRef.current,
    documentTitle: "LaporanKas",
  });

  const tampilPdf = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      let tempPersenLoading = parseInt(persenLoading);

      setTimeout(() => {
        tempPersenLoading += 40;
        setPersenLoading(tempPersenLoading.toString());
      }, "1000");

      let penerimaanKas = await axios.post(`${tempUrl}/penerimaanKas`, {
        // dariTanggal,
        sampaiTanggal,
        kas: setting.kas,
        kodeCabang,
        _id: user.id,
        token: user.token,
      });
      setPenerimaanKas(penerimaanKas.data);
      let penerimaanKasSampaiSekarang = await axios.post(
        `${tempUrl}/penerimaanKasSampaiSekarang`,
        {
          // dariTanggal,
          sampaiTanggal,
          kas: setting.kas,
          kodeCabang,
          _id: user.id,
          token: user.token,
        },
      );
      setPenerimaanKasSampaiSekarang(penerimaanKasSampaiSekarang.data);
      let tempTotalPenerimaanKasSampaiSekarang = 0;
      for (let data of penerimaanKasSampaiSekarang.data) {
        tempTotalPenerimaanKasSampaiSekarang += data.jumlah;
      }
      setTotalPenerimaanKasSampaiSekarang(tempTotalPenerimaanKasSampaiSekarang);

      let pengeluaranKas = await axios.post(`${tempUrl}/pengeluaranKas`, {
        // dariTanggal,
        sampaiTanggal,
        kas: setting.kas,
        kodeCabang,
        _id: user.id,
        token: user.token,
      });
      setPengeluaranKas(pengeluaranKas.data);
      let pengeluaranKasSampaiSekarang = await axios.post(
        `${tempUrl}/pengeluaranKasSampaiSekarang`,
        {
          // dariTanggal,
          sampaiTanggal,
          kas: setting.kas,
          kodeCabang,
          _id: user.id,
          token: user.token,
        },
      );
      setPengeluaranKasSampaiSekarang(pengeluaranKasSampaiSekarang.data);
      let tempTotalPengeluaranKasSampaiSekarang = 0;
      for (let data of pengeluaranKasSampaiSekarang.data) {
        tempTotalPengeluaranKasSampaiSekarang += data.jumlah;
      }
      setTotalPengeluaranKasSampaiSekarang(
        tempTotalPengeluaranKasSampaiSekarang,
      );

      setPreviewPdf(!previewPdf);
      setLoading(false);
      setTimeout(() => {
        tempPersenLoading = 0;
        setPersenLoading(tempPersenLoading.toString());
      }, "2000");
    }
  };

  useEffect(() => {
    getCabangsData();
    if (user.tipeUser !== "OWNER/DIREKSI") {
      setKodeCabang(user.cabang.id);
      setNamaCabang(`${user.cabang.id} - ${user.cabang.namaCabang}`);
    }
  }, []);

  const getCabangsData = async () => {
    const response = await axios.post(`${tempUrl}/cabangs`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setCabangs(response.data);
  };

  const tableText = {
    letterSpacing: "0.01px",
  };

  const tableTextBold = {
    letterSpacing: "0.01px",
    fontWeight: "bold",
  };

  const textBold = {
    fontWeight: 700,
    border: "1px solid black",
  };

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const textNumberRight = {
    textAlign: "right",
    border: "1px solid black",
  };

  const textNumberRightBold = {
    textAlign: "right",
    fontWeight: 700,
    border: "1px solid black",
  };

  const list = [];
  let sisa = 0;
  let totalPenerimaanKas = 0;
  let totalPengeluaranKas = 0;
  let totalSaldoAkhirMasuk = 0;
  let totalSaldoAkhirKeluar = 0;

  // Saldo Awal Penerimaan Kas
  list.push(
    <tr style={tableTextBold}>
      <td
        style={{ paddingLeft: "15px", border: "1px solid black" }}
        colSpan={7}
      >
        SALDO AWAL: KAS
      </td>
    </tr>,
  );
  sisa += totalPenerimaanKasSampaiSekarang - totalPengeluaranKasSampaiSekarang;
  // totalSaldoAkhirMasuk += totalPenerimaanKasSampaiSekarang;
  // totalSaldoAkhirKeluar += totalPengeluaranKasSampaiSekarang;
  list.push(
    <tr style={tableText}>
      <td style={{ paddingLeft: "15px", border: "1px solid black" }}>1</td>
      <td style={{ paddingLeft: "15px", border: "1px solid black" }}>S.AWAL</td>
      <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
        Saldo Kas Per Tanggal {formatDate(sampaiTanggal)}
      </td>
      <td style={textNumberRight}>
        {/* {isCetakExcel === false
          ? totalPenerimaanKasSampaiSekarang.toLocaleString("en-EN")
          : totalPenerimaanKasSampaiSekarang} */}
        0
      </td>
      <td style={textNumberRight}>
        {/* {isCetakExcel === false
          ? totalPengeluaranKasSampaiSekarang.toLocaleString("en-EN")
          : totalPengeluaranKasSampaiSekarang} */}
        0
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false ? sisa.toLocaleString("en-EN") : sisa}
      </td>
    </tr>,
  );
  // list.push(
  //   <tr style={tableTextBold}>
  //     <td
  //       style={{ paddingLeft: "15px", border: "1px solid black" }}
  //       colSpan={3}
  //     >
  //       TOTAL SALDO AWAL: KAS
  //     </td>
  //     <td style={textNumberRight}>
  //       {isCetakExcel === false
  //         ? totalPenerimaanKasSampaiSekarang.toLocaleString("en-EN")
  //         : totalPenerimaanKasSampaiSekarang}
  //     </td>
  //     <td style={textNumberRight}></td>
  //     <td style={textNumberRight}></td>
  //   </tr>,
  // );

  // Data Penerimaan Kas
  list.push(
    <tr style={tableTextBold}>
      <td
        style={{ paddingLeft: "15px", border: "1px solid black" }}
        colSpan={7}
      >
        PENERIMAAN : KAS
      </td>
    </tr>,
  );
  for (let i = 0; i < penerimaanKas.length; i++) {
    sisa += penerimaanKas[i].jumlah;
    totalPenerimaanKas += penerimaanKas[i].jumlah;
    totalSaldoAkhirMasuk += penerimaanKas[i].jumlah;
    list.push(
      <tr style={tableText}>
        <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
          {i + 1}
        </td>
        <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
          {penerimaanKas[i].noBukti}
        </td>
        <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
          {penerimaanKas[i].keterangan}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? penerimaanKas[i].jumlah.toLocaleString("en-EN")
            : penerimaanKas[i].jumlah}
        </td>
        <td style={textNumberRight}>0</td>
        <td style={textNumberRight}>
          {isCetakExcel === false ? sisa.toLocaleString("en-EN") : sisa}
        </td>
      </tr>,
    );
  }
  list.push(
    <tr style={tableTextBold}>
      <td
        style={{ paddingLeft: "15px", border: "1px solid black" }}
        colSpan={3}
      >
        TOTAL PENERIMAAN : KAS
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? totalPenerimaanKas.toLocaleString("en-EN")
          : totalPenerimaanKas}
      </td>
      <td style={textNumberRight}></td>
      <td style={textNumberRight}></td>
    </tr>,
  );

  // Data Pengeluaran Kas
  list.push(
    <tr style={tableTextBold}>
      <td
        style={{ paddingLeft: "15px", border: "1px solid black" }}
        colSpan={7}
      >
        PENGELUARAN : KAS
      </td>
    </tr>,
  );
  for (let i = 0; i < pengeluaranKas.length; i++) {
    sisa -= pengeluaranKas[i].jumlah;
    totalPengeluaranKas += pengeluaranKas[i].jumlah;
    totalSaldoAkhirKeluar += pengeluaranKas[i].jumlah;
    list.push(
      <tr style={tableText}>
        <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
          {i + 1}
        </td>
        <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
          {pengeluaranKas[i].noBukti}
        </td>
        <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
          {pengeluaranKas[i].keterangan}
        </td>
        <td style={textNumberRight}>0</td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? pengeluaranKas[i].jumlah.toLocaleString("en-EN")
            : pengeluaranKas[i].jumlah}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false ? sisa.toLocaleString("en-EN") : sisa}
        </td>
      </tr>,
    );
  }
  list.push(
    <tr style={tableTextBold}>
      <td
        style={{ paddingLeft: "15px", border: "1px solid black" }}
        colSpan={3}
      >
        TOTAL PENGELUARAN : KAS
      </td>
      <td style={textNumberRight}>0</td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? totalPengeluaranKas.toLocaleString("en-EN")
          : totalPengeluaranKas}
      </td>
      <td style={textNumberRight}></td>
    </tr>,
  );
  list.push(
    <tr style={tableTextBold}>
      <td
        style={{ paddingLeft: "15px", border: "1px solid black" }}
        colSpan={3}
      >
        SALDO AKHIR
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? totalSaldoAkhirMasuk.toLocaleString("en-EN")
          : totalSaldoAkhirMasuk}
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? totalSaldoAkhirKeluar.toLocaleString("en-EN")
          : totalSaldoAkhirKeluar}
      </td>
      <td style={textNumberRight}></td>
    </tr>,
  );

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "LaporanKas",
    sheet: "LaporanKas",
  });

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  return (
    <Container>
      <h3>Laporan</h3>
      <h5 style={{ fontWeight: 400 }}>Laporan Kas</h5>
      <hr />
      <Box sx={spacingTop}>
        <Form onSubmit={tampilPdf}>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Cabang :
                </Form.Label>
                <Col sm="8">
                  {user.tipeUser === "OWNER/DIREKSI" ? (
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={cabangOptions}
                      renderInput={(params) => (
                        <TextField
                          error={error && kodeCabang.length === 0 && true}
                          size="small"
                          placeholder="SEMUA CABANG"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setKodeCabang(value.id.split(" ", 1)[0]);
                          setNamaCabang(value.id);
                        } else {
                          setKodeCabang("");
                          setNamaCabang("");
                        }
                        setPengeluaranKas([]);
                        setPreviewPdf(false);
                      }}
                      defaultValue={kodeCabang}
                    />
                  ) : (
                    <Form.Control value={kodeCabang} disabled readOnly />
                  )}
                </Col>
              </Form.Group>
            </Col>
          </Row>
          {/* <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Dari :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={dariTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setDariTanggal(date);
                      setPengeluaranKas([]);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row> */}
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Per Tanggal :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={sampaiTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setSampaiTanggal(date);
                      setPengeluaranKas([]);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            type="submit"
            style={{ marginTop: "20px" }}
          >
            LIHAT
          </Button>
        </Form>
      </Box>

      {previewPdf && (
        <div style={{ marginTop: "10px" }}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button startIcon={<PrintIcon />} onClick={generatePDF}>
              PDF
            </Button>
            <Button
              startIcon={<SearchIcon />}
              onClick={() => {
                setIsCetakExcel(true);
                setTimeout(() => {
                  onDownload();
                }, "1000");
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </div>
      )}
      <div ref={reportTemplateRef} id="content" style={pdfContainer}>
        <div style={{ visibility: previewPdf === true ? "visible" : "hidden" }}>
          <p>
            {setting.namaPerusahaan} - {setting.alamatPerusahaan}
          </p>
          <p>({setting.kabupatenPerusahaan})</p>
          <p>{setting.kotaPerusahaan}</p>
          <p>NO. TELP. {setting.teleponPerusahaan}</p>
          <p>
            Dicetak Oleh: {user.username} | Tanggal:
            {` ${nowDate.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(nowDate.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${nowDate.getFullYear()} `}{" "}
            | Jam:{" "}
            {` ${nowDate.getHours().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${(nowDate.getMinutes() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${nowDate.getSeconds().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })} `}
          </p>
          <h5 style={{ textAlign: "center", fontWeight: "700" }}>
            Laporan Kas
          </h5>
          {/* <p>
            Dari Tanggal :
            {` ${dariTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(dariTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${dariTanggal.getFullYear()}`}
          </p> */}
          <p>
            Per Tanggal :
            {` ${sampaiTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(sampaiTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${sampaiTanggal.getFullYear()}`}
          </p>
          <p>Cabang : {namaCabang}</p>
          <p></p>

          <table class="styled-table" ref={tableRef}>
            <thead>
              <tr>
                <th style={{ border: "1px solid black" }}>NO.</th>
                <th style={{ border: "1px solid black" }}>BUKTI</th>
                <th style={{ border: "1px solid black" }}>KETERANGAN</th>
                <th style={{ border: "1px solid black" }}>MASUK</th>
                <th style={{ border: "1px solid black", textAlign: "center" }}>
                  KELUAR
                </th>
                <th style={{ border: "1px solid black", textAlign: "center" }}>
                  SISA
                </th>
              </tr>
            </thead>
            <tbody>{list}</tbody>
          </table>
        </div>
      </div>
    </Container>
  );
};

export default LaporanKas;

const spacingTop = {
  mt: 4,
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "10px",
  fontFamily: "sans-serif",
  width: "1000px",
};
